import { domainUrl } from '../constants';

export const API_PRODUCT_CATEGORIES = `${domainUrl}categories`;
export const API_PRODUCT_CATEGORY = `${domainUrl}categories/{id}`;
